<template>
  <div class="content">

    <!-- <div class="ctr-bar" v-show="loaded"> -->
    <div class="ctr-bar">
      <button class="ctr-btn" @click="handleClickClose">
        <span style="font-size: 1.2;">&times;</span>
      </button>
      <!-- <button class="ctr-btn" v-if="showTorchBtn" @click="torch = !torch">
        <i class="fa fa-flash"></i>
      </button> -->
    </div>

    <div class="target-area" v-show="loaded && !result">
      <div v-if="validating">
        <i class="fa fa-spinner fa-4x fa-pulse fa-fw"></i>
      </div>
    </div>

    <qrcode-stream class="camera"
        :camera="qrCamera ? 'auto' : 'off'"
        :torch="torch"
        @decode="onDecode"
        @init="onInit"
    >
      <div class="screen" v-show="paused">
        <div v-if="!validating && result" class="validation-result">
          <p class="result">{{ result.content }}</p>
          <div v-if="result.isUrl" class="valid">
            <div v-if="result.isExternal">
              <button @click="goTo(result.href)">
                Open <i class="fa fa-external-link"></i>
              </button>
            </div>
          </div>
          <div v-else class="invalid">
            This is not a URL...
          </div>
        </div>
      </div>
    </qrcode-stream>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'qr-camera-page',
  components: { QrcodeStream },
  data() {
    return {
      result: '',
      qrCamera: true,
      loaded: false,
      validating: false,
      isValid: false,
      showTorchBtn: false,
      torch: false,
    };
  },
  computed: {
    paused() {
      return !this.qrCamera;
    },
  },

  moundted() {
    this.qrCamera = true;
  },
  destroyed() {
    console.log('QR-stream destroyed');
    this.qrCamera = false;
  },

  methods: {
    init() {
      this.result = '';
      this.qrCamera = true;
      this.isValid = false;
    },

    onDecode(content) {
      console.log(`decoded: ${content}`);
      this.qrCamera = false;
      this.validating = true;
      this.validate(content).then((result) => {
        this.validating = false;
        this.result = result;
        if (this.isValid) {
          this.goPage(result);
        } else {
          window.setTimeout(() => {
            this.init();
          }, 3000);
        }
      });
    },

    validate(content) {
      return new Promise((resolve) => {
        window.setTimeout(() => {
          try {
            const url = new URL(content);
            this.isValid = true;
            resolve({
              content,
              isUrl: true,
              isExternal: url.hostname !== window.location.hostname,
              href: url.href,
              path: url.pathname,
              params: url.searchParams,
              hash: url.hash,
            });
          } catch (err) {
            this.isValid = false;
            resolve({
              content,
              isUrl: false,
            });
          }
        }, 1600);
      });
    },

    goPage(result) {
      if (!result.isExternal) {
        // TODO スタンプ処理
        if (result.params.has('reset')) {
          window.dataLayer.push({ event: 'reset_stamps' }); // gtm
          this.$store.dispatch('clearStamps');
        }
        if (result.params.has('stamp')) {
          const id = result.params.get('stamp');
          if (this.$store.state.stamps.find((s) => s.id === id)) {
            window.dataLayer.push({ event: 'get_stamp', stamp: id }); // gtm
            this.$store.commit('updateCurrentId', { id });
            // ハイライトアニメーションがかかるので、5秒以上まってから保存する
            window.setTimeout(() => {
              this.$store.dispatch('addStamp', { id }); // &セーブ付き
              this.$store.commit('clearCurrentId'); // ここで初期化しておく（連続読み込みに対応するため）
            }, 6000);
          }
        }

        if (this.$router.mode === 'hash') {
          // hashモードのときはhash文字列から先頭'#'を除いたものを渡す
          this.$router.push(result.hash.slice(1));
        } else {
          // historyモードのときはpathを渡す
          this.$router.push(result.path);
        }
        // this.$store.commit('ons/navigator/popPage');
        // this.$store.dispatch('page/updateStateFromRoute');
      }
    },

    goTo(url) {
      const newWindow = window.open(url, '_blank');
      newWindow.opener = null;
      newWindow.location = url;
    },

    onInit(promise) {
      promise.then((payload) => {
        const { capabilities } = payload;
        this.showTorchBtn = !!capabilities.torch;
        this.loaded = true;
      }).catch((err) => {
        /* eslint-disable no-console */
        console.error(err);
        window.alert(this.camera.error_message);
        this.handleClickClose();
      });
    },

    handleClickClose() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.camera {
  /* width: 100%; */
  height: 60vh;
}
.screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: rgba(255, 255, 255, 0.4);
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  color: hsla(210, 65%, 50%, 1);
}

.validation-result {
  margin: auto;
  padding: 10px;
  width: 80vw;
  color: #eee;
  background-color: rgba(0, 0, 0, 0.4);
}
.result {
  /* text-shadow: 1px 1px 8px #fff; */
}

.target-area {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: auto;
  width: 40vw;
  height: 40vw;
  background-color: transparent;
  border: 2px solid hsla(210, 65%, 50%, 0.8);
  color: hsla(210, 65%, 50%, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ctr-bar {
  display: flex;
  flex-flow: row-reverse;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  padding: 0 10px;
  width: 100%;
  height: 60px;
  line-height: 60px;
  z-index: 1000;
  /* background-color: rgba(0, 0, 0, 0.4); */
  background: #07a79d;
}
.ctr-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 8px;
  padding: 0;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background-color: rgba(255,255,255,0.9);
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,0.6);
  outline: none;
  color: #333;
}
</style>
